<template>
  <div class="animated fadeIn arpaymfrm">
    <b-card>
      <div slot="header">
        Payment Settlement - Form
        <div class="card-header-actions">
          <button class="btn btn-warning mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <div slot="footer">
        <b-row class="justify-content-md-center">
          <b-col cols="12" md="auto">
            <b-input-group>
            <b-input-group-prepend
              ><span class="p-2"
                >Add Trx. after save</span
              ></b-input-group-prepend
            >
            <b-form-checkbox
              v-model="inputBerlanjut"
              :value="1"
              :unchecked-value="0"
              class="pt-2"
            ></b-form-checkbox>
            <b-input-group-append>
              <!-- <button
                v-if="saveEnabled"
                class="btn btn-primary mr-1"
                @click="save()"
              >
                <i class="fa fa-save"></i> Save
              </button> -->
              <button
                v-if="saveEnabled"
                class="btn btn-success mr-1"
                @click="save(1)"
              >
                <i class="fa fa-save"></i> Save To Accounting
              </button>
              <button class="btn btn-warning mr-1" @click="close()">
                <i class="fa fa-close"></i> {{ $t("close") }}
              </button>
            </b-input-group-append>
          </b-input-group>
          </b-col>
        </b-row>
      </div>
      <b-row>
        <b-col lg="8">
          <b-input-group>
              <b-input-group-prepend><label class="label-md">Trx Bank No.</label></b-input-group-prepend>
              <b-form-input v-model="model.nomor"></b-form-input>
              <b-input-group-prepend><span class="p-2">Collection No.</span></b-input-group-prepend>
              <b-form-input v-model="model.paymno" v-b-tooltip.hover title="Jika dikosongkan akan dibuatkan otomatis"></b-form-input>
              <b-input-group-prepend><span class="p-2">Payment Date</span></b-input-group-prepend>
              <b-form-input v-model="model.tglpaym" type="date" :state="!$v.model.tglpaym.$error"></b-form-input>
          </b-input-group>
          <b-row>
            <b-col lg="8">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">Terima Dari <br>(CIF|Nm. Debitur)</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.custinfo"
                  :state="!$v.model.customer_id.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="4">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">Kolektor</span></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.collector_id"
                  :plain="true"
                  :options="collectors"
                  disabled="disabled"
                ></b-form-select>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label class="label-md">No Agreement</label></b-input-group-prepend
                >
                <b-form-input
                  readonly
                  v-model="model.pinjamaninfo"
                ></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuPinjamanShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="p-2">No Kontrak</span></b-input-group-prepend
                >
                 <b-form-input
                  readonly
                  v-model="model.no_kontrak"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-md"></label>
            </b-input-group-prepend>
            <a :href="viewaggrementcard()" target="_blank"><i class="fa fa-eye"></i> View Aggrement Card</a>
          </b-input-group>
          <b-input-group>
            <span class="pt-2 pr-2">Kelompok Pembayaran</span>
            <span v-if="model.paym_group == 'WO'" class="input-group-text">WO</span>
            <span v-else class="input-group-text">Normal</span>
            <!-- <span class="p-2 ml-2">Status Payment Pelunasan</span>
            <span v-if="model.pelunasan_bertahap" class="input-group-text">Bertahap (Ada Memo Pelunasan)</span>
            <span v-else class="input-group-text">Angsuran (Tidak ada Memo Pelunasan)</span> -->
          </b-input-group>  
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important"
                >Total Settle Pembayaran</label
              ></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.totalbyr"
              :precision="2"
              :minus="true"
              :state="!$v.model.totalbyr.$error"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important"
                >Jumlah Terima Kas/bank
              </label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.totalbank"
              :state="!$v.model.totalbank.$error"
              :precision="2"
              :minus="true"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important"
                >Jumlah Potongan/Diskon</label
              ></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                uanguser
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.totaldiskon"
              :state="!$v.model.totaldiskon.$error"
              :precision="2"
              :minus="true"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend
              ><label style="min-width: 180px !important"
                >Jumlah Prepaid</label
              ></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                uanguser
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.pbb_amt"
              :precision="2"
              :minus="true"
              readonly
            ></my-number>
          </b-input-group>
          <b-input-group v-if="model.matauang != uanguser">
            <b-input-group-prepend
              ><label style="width: 180px !important"
                >Nilai Kurs {{ model.matauang || "" }} ke {{ uanguser }}
              </label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                uanguser
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.kurstrx"
              :precision="6"
            ></my-number>
          </b-input-group>
        </b-col>
      </b-row>
      <!-- <hr /> -->
      <b-table bordered small
      :items="tblDataMemo.items" 
      :fields="tblFieldsMemo" caption-top class="mt-0" show-empty>
        <template #table-caption style="margin-top:0px;"><b>Memo Pelunasan</b></template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(ttlmustpay)="data">{{ data.item.ttlmustpay | numFormat('0,0.00') }}</template>
        <template v-slot:cell(CONTRACT_PREPAID_AMT)="data">{{ data.item.CONTRACT_PREPAID_AMT | numFormat('0,0.00') }}</template>
        <template
          v-slot:cell(tglsurat)="data"
        >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(tgl_kontrak)="data"
        >{{ data.item.tgl_kontrak | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(tglpelunasan)="data"
        >{{ data.item.tglmulaipelunasan | moment("DD MMM YYYY") }} - {{ data.item.tglpelunasan | moment("DD MMM YYYY") }}</template>
        <template
                v-slot:cell(status_memo)="data"
              >
                <span v-if="data.item.isreject==1">Rejected</span>
                <span v-else-if="data.item.issuccess==1">Approved</span>
                <span v-else-if="data.item.send2wf==1">Send Approval</span>
                <span v-else-if="data.item.isexpired==1">Expired</span>
                <span v-else-if="data.item.ispaid==1">PAID ({{data.item.paid_date | moment('DD-MM-YYYY')}})</span>
                <span v-else>-</span>
              </template>
      </b-table>
      <!-- <hr /> -->
       <b-table bordered small
      :items="tblDataPelepasanJmn.items" 
      :fields="tblFieldsPelepasanJaminan" caption-top class="mt-0" show-empty>
        <template #table-caption style="margin-top:0px;"><b>Memo Pelepasan Jaminan Sebagian</b></template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(paymentamt)="data">{{ data.item.paymentamt | numFormat('0,0.00') }}</template>
        <template v-slot:cell(jaminanamt)="data">{{ data.item.jaminanamt | numFormat('0,0.00') }}</template>
        <template v-slot:cell(nilailikuidasi)="data">{{ data.item.nilailikuidasi | numFormat('0,0.00') }}</template>
        <template
          v-slot:cell(submitdate)="data"
        >{{ data.item.submitdate | moment("DD MMM YYYY") }}</template>
        <template
          v-slot:cell(duedate_memo)="data"
        >{{ data.item.duedate_memo | moment("DD MMM YYYY") }}</template>
        <template
                v-slot:cell(status_memo)="data"
              >
                <span v-if="data.item.isreject==1">Rejected</span>
                <span v-else-if="data.item.issuccess==1">Approved</span>
                <span v-else-if="data.item.send2wf==1">Send Approval</span>
                <span v-else-if="data.item.isexpired==1">Expired</span>
                <span v-else-if="data.item.ispaid==1">PAID ({{data.item.paid_date | moment('DD-MM-YYYY')}})</span>
                <span v-else>-</span>
              </template>
      </b-table>
      <!--  -->
      <b-table bordered small
      :items="tblDataSP.items" :fields="tblFieldsSP" caption-top class="mt-0" show-empty>
        <template #table-caption style="margin-top:0px;"><b>Surat Peringatan</b></template>
        <template #empty="scope">
          <h6 class="text-center">{{ scope.emptyText }}</h6>
        </template>
        <template #emptyfiltered="scope">
          <h6 class="text-center">{{ scope.emptyFilteredText }}</h6>
        </template>
        <template v-slot:cell(tunggakantotal)="data">{{ data.item.tunggakantotal | numFormat }}</template>
        <template v-slot:cell(modified_by)="data">{{ data.item.modified_by ? data.item.modified_by : '-'}}</template>
        <template
          v-slot:cell(tglsurat)="data"
        >{{ data.item.tglsurat | moment("DD MMM YYYY") }}</template>
        <template v-slot:cell(debitur_name)="data">{{ data.item.CustCode}} | {{data.item.CustName}}</template>
      </b-table>
      <hr />
      <b-row>
        <b-col lg="10">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>DOD</label>
                </b-input-group-prepend>
                 <my-number
                  class="form-control text-right"
                  v-model="model.days_over_due"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS LC Installament</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.latecharge_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
           <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Principal Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.principal_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>OS Interest Undue</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.interest_outstand_undue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row v-if="model.pinjaman=='PAB'">
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row v-if="model.pinjaman=='PAB'">
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Installment Due No	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.next_installment_due_no"
                  :precision="0"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Next Due Date	</label>
                </b-input-group-prepend>
                <b-form-input v-model="model.next_installment_due_date" disabled></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Prepaid	</label>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right  bg-warning text-black" style="color:black !important"
                  v-model="model.pbb_os"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend>
              <label class="label-md">Keterangan / <br />Catatan</label>
            </b-input-group-prepend>
            <b-form-textarea
              :rows="2"
              :max-rows="5"
              v-model="model.uraian"
              :state="!$v.model.uraian.$error"
            ></b-form-textarea>
          </b-input-group>
        </b-col>
      </b-row>
      <label v-if="model.paym_group=='NM' && (model.pelunasan==0) "><strong>Detail Settlement</strong></label>
      <b-card no-body class="mt-0" v-if="model.paym_group=='NM' && (model.pelunasan==0) ">
        <b-table
          class="mb-0"
          ref="tblArpaymdt"
          outlined
          striped
          hover
          small
          style="font-size: smaller"
          :items="arpaymdt.items"
          :fields="arpaymdt.fields"
          :current-page="arpaymdt.page"
          :per-page="arpaymdt.limit"
          show-empty
        >
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          
          <template v-slot:cell(tgl_jttempo)="data">
            {{ data.item.tgl_jttempo | moment('DD/MM/YYYY') }}
          </template>
          <template v-slot:cell(nilaisettl)="data">
            {{ data.item.nilaisettl | numFormat("(0,0.00)") }}
          </template>
          <template v-slot:cell(kurssettle)="data">
            {{ data.item.kurssettle | numFormat("(0,0.00)") }}
          </template>
          <template v-slot:cell(nilaibank)="data">
            {{ data.item.nilaibank | numFormat("(0,0.00)") }}
          </template>
          <template v-slot:cell(nilaidiskon)="data">
            {{ data.item.nilaidiskon | numFormat("(0,0.00)") }}
            <div v-if="data.item.Potongan">{{ data.item.Potongan |numFormat("(0,0.00)")}}</div>
          </template>
          <template v-slot:cell(selisihkurs)="data">
            {{ data.item.selisihkurs | numFormat("(0,0.00)") }}
          </template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a
                href="javascript:void(0)"
                @click="editArpaymdt(data.item, data.toggleDetails)"
              >
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click="delArpaymdt(data.index)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
          <template v-slot:row-details="row">
            <b-card no-body class="row-details-form">
              <b-row align-h="around" class="p-1">
                <b-col lg="6">
                  <b-input-group>
                    <b-input-group-prepend
                      ><label>Nama Debitur</label></b-input-group-prepend
                    >
                    <b-form-input
                      v-model="arpaymdtObj.CustName"
                      disabled
                      style="width: 35% !important"
                    ></b-form-input>
                    <b-input-group-prepend
                      ><span class="input-group-text"
                        >No. Pinjaman</span
                      ></b-input-group-prepend
                    >
                    <b-form-input
                      readonly
                      v-model="arpaymdtObj.no_kontrak"
                      @keyup.13.native="lkuPinjamanoutstandShow = true"
                      :state="!$v.arpaymdtObj.pinjamankey.$error"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-btn
                        text="Button"
                        @click="lkuPinjamanoutstandShow = true"
                      >
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                  <b-input-group>
                    <b-input-group-prepend
                      ><label>Penggunaan Pinjaman</label></b-input-group-prepend
                    >
                    <b-form-input
                      v-model="arpaymdtObj.uraian"
                      disabled
                    ></b-form-input>
                  </b-input-group>
                  <b-row no-gutters>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Outstanding Pokok</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.outstand_pokok"
                          :precision="2"
                          disabled
                        ></my-number>
                      </b-input-group>
                    </b-col>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Outstanding Denda</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.outstand_denda"
                          :precision="2"
                          disabled
                        ></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Outstanding Bunga</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.outstand_bunga"
                          :precision="2"
                          disabled
                        ></my-number>
                      </b-input-group>
                    </b-col>
                    <b-col lg="6">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >TOTAL Outstanding</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.outstand"
                          :precision="2"
                          readonly
                        ></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>
                 
                </b-col>
                <b-col lg="6">
                  <b-row no-gutters>
                    <b-col lg="5">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label>Jenis Settle</label></b-input-group-prepend
                        >
                        <b-form-select
                          v-model="arpaymdtObj.nilaisettl_desc"
                          :plain="true"
                          :options="['POKOK', 'BUNGA', 'DENDA']"
                          :state="!$v.arpaymdtObj.nilaisettl_desc.$error"
                        ></b-form-select>
                      </b-input-group>
                    </b-col>
                    <b-col lg="7">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Nilai Settlement</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.nilaisettl"
                          :state="!$v.arpaymdtObj.nilaisettl.$error"
                          @change="updateNilaibank"
                          :precision="2"
                          :disabled="
                            model.model_pinjaman == 'PAB' &&
                            arpaymdtObj.nilaisettl_desc != 'DENDA'
                          "
                        ></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>

                  <b-row no-gutters>
                    <b-col offset="5" lg="7">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Settle dg Diskon</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 60px">{{
                            model.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.nilaidiskon"
                          :precision="2"
                        ></my-number>
                      </b-input-group>
                    </b-col>
                    <b-col offset="5" lg="7">
                      <b-input-group>
                        <b-input-group-prepend
                          ><label
                            >Settle dg Kas/Bank</label
                          ></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            model.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.nilaibank"
                          :precision="2"
                          :state="!$v.arpaymdtObj.nilaibank.$error"
                        ></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row no-gutters>
                    <b-col lg="5"> </b-col>
                    <b-col lg="7">
                      <b-input-group
                        v-if="model.matauang != arpaymdtObj.matauang"
                      >
                        <b-input-group-prepend
                          ><label
                            >Kurs {{ model.matauang }}
                          </label></b-input-group-prepend
                        >
                        <b-input-group-prepend
                          ><span class="input-group-text" style="width: 70px">{{
                            arpaymdtObj.matauang
                          }}</span></b-input-group-prepend
                        >
                        <my-number
                          class="form-control text-right my-number"
                          v-model="arpaymdtObj.kurssettle"
                          :precision="6"
                          :state="!$v.arpaymdtObj.kurssettle.$error"
                        ></my-number>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-input-group>
                    <b-input-group-prepend
                      ><label>Cash Flow Account</label></b-input-group-prepend
                    >
                    <b-form-input
                      readonly
                      v-model="arpaymdtObj.cashflow"
                      @keyup.13.native="showLkuCashflow('arpaymdt')"
                      :state="!$v.arpaymdtObj.kodecash.$error"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCashflow('arpaymdt')">
                        <i class="fa fa-search"></i>
                      </b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>

              <b-row class="justify-content-center mb-2">
                <div style="width: 400px">
                  <b-input-group>
                    <b-input-group-prepend
                      ><span class="p-2"
                        >Add Line after update</span
                      ></b-input-group-prepend
                    >
                    <b-form-checkbox
                      v-model="inputLineBerlanjut"
                      :value="1"
                      :unchecked-value="0"
                      class="pt-2"
                    ></b-form-checkbox>
                    <b-input-group-append>
                      <b-button
                        class="btn btn-success mr-1"
                        @click="saveArpaymdt()"
                        >Update</b-button
                      >
                    </b-input-group-append>
                    <b-input-group-append>
                      <b-button
                        class="btn btn-warning ml-1"
                        @click="row.toggleDetails"
                        >Cancel</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </b-row>
            </b-card>
          </template>
          <template v-slot:empty="scope">
            <h6 class="text-center">
              Tidak ada data detail settlement.
              <!-- {{ scope.emptyText }} -->
            </h6>
          </template>
          <template v-slot:emptyfiltered="scope">
            <h6>{{ scope.emptyFilteredText }}</h6>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="9">
            <b-row>
              <b-col cols="3">
                <b-button
                  v-if="(model.pelunasankey||'') != ''"
                  size="sm"
                  class="ml-1"
                  @click="addArpaymdt"
                  :disabled="!model.customer_id"
                  >Add Settlement</b-button
                >
                <b-button
                  v-else
                  size="sm"
                  class="ml-1"
                  @click="addPaymLoan"
                  :disabled="!model.customer_id"
                  >Add Settlement
                </b-button>
                <!-- <b-button size="sm" class="ml-1" @click="addArpaymdt" >Add Settlement</b-button>                           -->
              </b-col>
              <b-col cols="9">
                <div style="display: flex; margin: 0; padding: 0">
                  <div
                    style="
                      margin: 0;
                      padding: 5px;
                      width: 500px;
                      text-align: right;
                    "
                  >
                    Showing {{ (arpaymdt.page - 1) * arpaymdt.limit + 1 }} to
                    <span
                      v-if="arpaymdt.page * arpaymdt.limit > arpaymdt.total"
                      >{{ arpaymdt.total }}</span
                    >
                    <span v-else>{{ arpaymdt.page * arpaymdt.limit }}</span> of
                    {{ arpaymdt.total }} , <span class="mr-1"> per page :</span>
                    <select v-model="arpaymdt.limit" style="width: 60px">
                      <option>5</option>
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                  <div>
                    <b-pagination
                      class="ml-1"
                      align="left"
                      :total-rows="arpaymdt.total"
                      :per-page="arpaymdt.limit"
                      v-model="arpaymdt.page"
                    ></b-pagination>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="3">
            <b-input-group>
              <b-input-group-prepend
                ><label style="width: 170px !importnat"
                  >Total Detail Settlement</label
                ></b-input-group-prepend
              >
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 70px">{{
                  model.matauang
                }}</span>
              </b-input-group-prepend>
              <my-number
                class="form-control text-right my-number"
                v-model="totalDtlPaym"
                :precision="2"
                disabled
              ></my-number>
            </b-input-group>
          </b-col>
        </b-row>
      </b-card>
      <b-row align-h="between">
        <b-col lg="7">
          <b-row>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Payment Method</label></b-input-group-prepend
                >
                <b-form-select
                  v-model="model.jenis"
                  :plain="true"
                  :options="jenisPaym"
                  :state="!$v.model.jenis.$error"
                ></b-form-select>
              </b-input-group>
            </b-col>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Due/Efective Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_terima"
                  type="date"
                  :state="!$v.model.tgl_terima.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cheque/Giro No.</label></b-input-group-prepend
                >
                <b-form-input v-model="model.nomorcek"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col
              lg="6"
              v-if="model.jenis === 'Cheque' || model.jenis === 'Giro'"
            >
              <b-input-group>
                <b-input-group-prepend
                  ><label>Cheque/Giro Date</label></b-input-group-prepend
                >
                <b-form-input
                  v-model="model.tgl_giro"
                  type="date"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="6" v-if="model.jenis != 'Tunai'">
              <b-input-group>
                <b-input-group-prepend
                  ><label>Bank Debitur</label></b-input-group-prepend
                >
                <b-form-input v-model="model.bankasal"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-col>
        <b-col lg="4">
          <b-input-group>
            <b-input-group-prepend
              ><label>Finance Account</label></b-input-group-prepend
            >
            <b-form-input
              readonly
              v-model="model.namabank"
              @keyup.13.native="lkuBankaccountShow = true"
              :state="!$v.model.namabank.$error"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuBankaccountShow = true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append>
              <span class="input-group-text" style="width: 60px">{{
                model.matauang
              }}</span>
            </b-input-group-append>
          </b-input-group>
          <b-input-group v-if="this.model.isbank == '1'">
            <b-input-group-prepend
              ><label>Bank Account#</label></b-input-group-prepend
            >
            <b-form-input disabled v-model="model.nomorrek"></b-form-input>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend
              ><label>Bank Charges</label></b-input-group-prepend
            >
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 70px">{{
                model.matauang
              }}</span></b-input-group-prepend
            >
            <my-number
              class="form-control text-right my-number"
              separator=","
              v-model="model.bcharges"
              :precision="2"
            ></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
            <b-input-group-append class="ml-2">
              <div class="text-center">
               
              </div>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuPinjamanShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman Belum Lunas (RRD)"
      :centered="true"
    >
      <lku-pinjaman
        @click="onSelectLkuPinjaman"
        :customer="model.custinfo"
        :nasabahkey="model.customer_id"
        :selectedrow="selectedPinjaman"
      ></lku-pinjaman>
    </b-modal>
    <b-modal
      v-model="lkuPinjamanoutstandShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Pinjaman Outstanding"
      :key="model.customer_id"
      :centered="true"
    >
      <lku-pinjamanoutstand
        @click="onSelectLkuPinjamanoutstand"
        :model="model"
        :tglsettl="model.tglpaym"
        :formdata="lkuPinjamanoutstandData"
        :selectedrow="selectedPinjamanOS"
      ></lku-pinjamanoutstand>
    </b-modal>
    <b-modal
      v-model="lkuCashflowShow"
      size="lg"
      :hide-footer="true"
      title="List of Cashflow Account"
      :centered="true"
    >
      <lku-cashflow @click="onSelectLkuCashflow"></lku-cashflow>
    </b-modal>
    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Debitur"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
    <b-modal
      v-model="lkuBankaccountShow"
      size="lg"
      :hide-footer="true"
      title="List of Bank/Cash Account"
      :centered="true"
    >
      <lku-bankaccount
        @click="onSelectLkuBankaccount"
        :isbank="bankOnly"
        :key="bankOnly"
      ></lku-bankaccount>
    </b-modal>
    <b-modal
      v-model="confirmPelunasanBthpShow"
      title="Konfirmasi"
      :centered="true"
      @ok="confirmPelunasanBertahap('Yes')"
      @cancel="confirmPelunasanBertahap('No')"
    >
      <p class="my-2">Pinjaman ini pelunasan bertahap/langsung</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       

  </div>
</template>
<style lang="scss">
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 120px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}

.my-number{
  min-width:100px;
}

.label-md{
  width:150px !important;
}
</style>

<script>
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
// import vDim from "../lookup/dim";
import lkuPinjamanoutstand from "./lkuPinjamanoutstand";
import lkuPinjaman from "./lkuPinjamanBlmLunas";
import lkuBankaccount from "../lookup/lkuBankaccount";
import lkuCashflow from "../lookup/lkuCashflow";
import lkuCustomer from "./lkuDebitur";
import arpayment from "../../apis/pinjamanpayment";
import crud from "../../apis/crud";
import pelunasan from "../../apis/pelunasanpinjaman";
import suratperingatan from "../../apis/suratperingatan";
import releasedoc from "../../apis/releasedoc";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import { validationMixin } from "vuelidate";
import {
  required,
  requiredIf,
  maxValue,
  minValue
} from "vuelidate/lib/validators";
toastr.init();

export default {
  components: {
    myNumber,
    lkuPinjamanoutstand,
    lkuPinjaman,
    lkuBankaccount,
    lkuCashflow,
    lkuCustomer,
    Loading
  },
  mixins: [validationMixin],
  validations: {
    model: {
      uraian: { required },
      tglpaym: { 
        required:function () {
          let tglpaym = this.model.tglpaym;
          if((tglpaym||'')==""){
            return true;
          }else if(moment(tglpaym).diff(this.timeServer,'days')<1){
           return true;
          }else{
            return false;
          }
        }
      },
      jenis: { required },
      tgl_terima: {
        required: function () {
          if (this.model.jenis !== "Cheque" && this.model.jenis !== "Giro") {
            return true;
          } else if (this.model.tgl_terima) {
            return true;
          } else return false;
        },
      },
      namabank:{ required },
      matauang: { required },
      customer_id: { required },
      totalbyr: { required, minValue: minValue(0.0) },
      totalbank: { required, minValue: minValue(0.01) },
      totaldiskon: {
        required: requiredIf(function () {
          return this.adaNilaiDiskon;
        }),
        minValue: minValue(0.0),
      },
      kurstrx: { required, minValue: minValue(0.00000001) },
    },
    arpaymdtObj: {
      pinjamankey: { required },
      nilaisettl_desc: { required },
      nilaisettl: {
        minValue: function () {
          if (this.adaPotongan) {
            return true;
          } else if ((this.arpaymdtObj.nilaisettl || 0) < 0.01) {
            return false;
          } else return true;
        },
      },
      nilaibank: {
        minValue: function () {
          if (this.adaPotongan) {
            return true;
          } else if ((this.arpaymdtObj.nilaibank || 0) < 0) {
            return false;
          } else return true;
        },
      },
      nilaidiskon: {
        required: function () {
          if ((this.arpaymdtObj.nilaibank || 0) > 0.01) {
            return true;
          } else if ((this.arpaymdtObj.nilaidiskon || 0) < 0) {
            return false;
          } else return true;
        },
      },
      kurssettle: { required, minValue: minValue(0.0000001) },
      kodecash: {
        required: function () {
          // if ((this.arpaymdtObj.nilaibank || 0) == 0) {
          //   return true;
          // } else if ((this.arpaymdtObj.kodecash || "") == "") {
          //   return false;
          // } else 
          return true;
        },
      },
    },
  },
  data() {
    return {
      isLoading:false,
      arGroups: [],
      collectors: [],
      paym_group: [
        { text: "Normal", value: "NM" },
        { text: "WO", value: "WO" },
      ],
      selectedPinjamanOS: [],
      selectedPinjaman:[],
      currency: [{ value: "IDR", text: "IDR" }],
      potongans: [],
      saveEnabled: true,
      horizontal: true,
      jenisPaym: ["Cheque", "Giro", "Transfer", "Tunai"],
      model: {
        jenis: "Transfer",
        kodecash: "",
        kodebank: "",
        kurstrx: 1,
        tglpaym: moment().format("YYYY-MM-DD"),
        tgl_terima: moment().format("YYYY-MM-DD"),
        // tgl_terima:moment().format("YYYY-MM-DD"),
        totalbank: 0,
        totaldiskon: 0,
        matauang: "",
        totalbyr: "",
        custcode:"",
        CustName:"",
        customer_id: "",
        collector_id:"",
        settl_amt: 0,
        paym_group: "NM",
        pelunasan_bertahap:0,
        pelunasan:0,
        ismemo: 0,
        namabank:'',
        postToAccounting:0
      },
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lblExchRate: "Exch. Rate ",
      bankOnly: 1,
      lkuBankaccountShow: false,
      lkuCashflowShow: false,
      lkuCashflowCaller: "arpaymdt",
      totalDtlPaym: 0,
      updateDimHdr: false,
      updateDimDtl: true,
      arpaymdt: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "no_kontrak",
            label: "No. Kontrak",
            thStyle: "width:140px",
            sortable: true,
          },
          {
            key: "uraian",
            label: "Uraian Pinjaman",
            sortable: true,
          },
          {
            key: "angsuran_ke",
            label: "Angsuran ke-",
            thStyle: "width:60px",
            sortable: true,
          },
          {
            key: "tgl_jttempo",
            thStyle: "width:90px",
            label: "Tgl. Jt.Tempo",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true,
          },
          {
            key: "nilaisettl_desc",
            label: "Jenis Settlement",
            thStyle: "width:100px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "nilaisettl",
            label: "Nilai Settlement",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true,
          },
          {
            key: "nilaibank",
            label: "Nilai Cash/Bank",
            thStyle: "width:142px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidiskon",
            label: "Nilai Diskon",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "cashflow",
            label: "Cashflow Acc.",
            sortable: true,
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 90,
        total: 0,
      },
      arpaymdtObj: {
        pinjamankey: "",
        kodecash: "",
        nilaisettl_desc: "POKOK",
        nilaidiskon: 0,
        nilaibank: 0,
        nilaisettl: 0,
      },
      lkuPinjamanoutstandShow: false,
      lkuPinjamanShow: false,
      addPrincipInterest: false,
      lkuPinjamanoutstandData: {},
      lkuCustomerShow: false,
      confirmPelunasanBthpShow: false,
      pelunasanbertahap: false,
      selectedOSPinjaman :{},
      tabIndex: 0,
      minpay: 0,
      items:[],fields: ['first_name', 'last_name', 'age'],
      tblDataMemo: {
        items:[],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",nosurat:""
      },
      tblDataPelepasanJmn: {
        items:[],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "tglpelunasan",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        status: "",nosurat:""
      },
      tblDataSP: {
        page: 1,
        limit: 15,
        total: 0,
        items:[],
        sortBy: "tglsurat",
        sortDesc: false,
        model_pinjaman: "",
        collector_id: "",
        collectability: "",
        kolektibiltas: "",
        jenissuratkey: null,
      },
    };
  },
  computed: {
    uanguser() {
      return this.$store.state.user.matauang;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidArpaymdt() {
      this.$v.arpaymdtObj.$touch();
      return this.$v.arpaymdtObj.$invalid;
    },
    caraBayar() {
      return this.model.jenis;
    },
    bankkas() {
      return this.model.kodebank;
    },
    adaPotongan() {
      return (this.arpaymdtObj.nilaidiskon || 0) != 0;
    },
    nilaisettl_desc() {
      return this.arpaymdtObj.nilaisettl_desc;
    },
    adaNilaiBank() {
      return (this.arpaymdtObj.nilaibank || 0) != 0;
    },
    adaNilaiDiskon() {
      return this.model.paym_group == "WO";
    },
     tblFieldsMemo() {
      const fields = [
         {
          key: "tglsurat",
          label: "Tgl. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
         {
          key: "tipepelunasan",
          label: "Jenis Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tglpelunasan",
          label: "Tgl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "CONTRACT_PREPAID_AMT",
          label: "Ttl. Prepaid",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "ttlmustpay",
          label: "Ttl. Pelunasan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createby",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
    tblFieldsPelepasanJaminan() {
      const fields = [
        
         {
          key: "submitdate",
          label: "Tgl. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "releaseno",
          label: "No. Memo",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "duedate_memo",
          label: "Tgl. Jth Tempo",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "paymentamt",
          label: "Ttl. Bayar (Harus)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "paid",
          label: "Ttl. Bayar (Sudah)",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
        },
        {
          key: "jaminanttl",
          label: "Jml. Jaminan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "jaminanamt",
          label: "Nilai Jaminan",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "status_memo",
          label: "Status Memo",
          thStyle: "width:150px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "createdbyfull",
          label: "Issued By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modifiedby",
          label: "Modified By",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
      ];
      return fields;
    },
    tblFieldsSP() {
      const fields = [
        {
          key: "no_kontrak",
          label: "No. Kontrak",
          thStyle: "width:140px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "nosurat",
          label: "No. SP",
          thStyle: "width:90px",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "tglsurat",
          label: "Tgl. SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "namasurat",
          label: "Jenis SP",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "kolektibiltas",
          label: "Kolektibiltas",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "tunggakantotal",
          label: "Tunggakan Total",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "createby",
          label: "DIterbitkan Oleh",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        },
        {
          key: "modified_by",
          label: "Modified by",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-center",
          sortable: true,
        }
      ];
      return fields;
    },
    user(){
      return this.$store.state.user;
    },
    timeServer(){
      return moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
    }
  },
  watch: {
    "arpaymdtObj.nilaisettl_desc": function (newVal) {
      switch (newVal) {
        case "BUNGA":
          this.arpaymdtObj.nilaisettl = this.arpaymdtObj.outstand_bunga;
          this.arpaymdtObj.nilaibank = this.arpaymdtObj.outstand_bunga;
          this.arpaymdtObj.nilaisettl_pokok = 0;
          this.arpaymdtObj.nilaisettl_bunga = this.arpaymdtObj.nilaisettl;
          this.arpaymdtObj.nilaisettl_denda = 0;
          break;

        case "DENDA":
          this.arpaymdtObj.nilaisettl = this.arpaymdtObj.outstand_denda;
          this.arpaymdtObj.nilaibank = this.arpaymdtObj.outstand_denda;
          this.arpaymdtObj.nilaisettl_pokok = 0;
          this.arpaymdtObj.nilaisettl_bunga = 0;
          this.arpaymdtObj.nilaisettl_denda = this.arpaymdtObj.nilaisettl;
          break;

        default:
          this.arpaymdtObj.nilaisettl = this.arpaymdtObj.outstand_pokok;
          this.arpaymdtObj.nilaibank = this.arpaymdtObj.outstand_pokok;
          this.arpaymdtObj.nilaisettl_pokok = this.arpaymdtObj.nilaisettl;
          this.arpaymdtObj.nilaisettl_bunga = 0;
          this.arpaymdtObj.nilaisettl_denda = 0;
          break;
      }
    },
    "model.totalbyr": function (newVal) {
      this.model.totaldiskon = newVal - this.model.totalbank;
      this.model.totaldiskon =
        this.model.totaldiskon < 0 ? 0 : this.model.totaldiskon;
      let pbb_amt =this.model.totalbank - ( newVal + this.model.totaldiskon )
      this.model.pbb_amt = pbb_amt > 0 ?pbb_amt:0;
    },
    "model.totalbank": function (newVal) {
      this.model.totaldiskon = this.model.totalbyr - newVal;
    },
    "model.totaldiskon": function (newVal) {
      this.model.totaldiskon =
        this.model.totaldiskon < 0 ? 0 : this.model.totaldiskon;
      let pbb_amt =this.model.totalbank - (this.model.totalbyr -newVal)
      this.model.pbb_amt = pbb_amt > 0 ?pbb_amt:0;
      if(newVal>0.009){
        let diskon = newVal;
        let listarpaymdt = this.arpaymdt.items;
        const ttlnilaidiskon = listarpaymdt.reduce((ttl=0,dt)=>{
          ttl += dt.nilaidiskon;
          return ttl;
        },0);
        let listpayinteres = listarpaymdt.filter(x=>(x.nilaisettl_desc).toUpperCase()=='BUNGA');
        let listpayprinciple = listarpaymdt.filter(x=>(x.nilaisettl_desc).toUpperCase()=='POKOK');
        let listpay = listpayinteres.concat(listpayprinciple);
        for (let index = 0; index < listpay.length; index++) {
          listpay[index].nilaidiskon=0;
        }
        for (let index = 0; diskon > 0; index++) {
          console.log('listpay[index]',listpay[index]);
          listpay[index].nilaidiskon = diskon>listpay[index].nilaisettl?listpay[index].nilaisettl:diskon;
          listpay[index].nilaibank = listpay[index].nilaisettl - listpay[index].nilaidiskon;
          diskon -=listpay[index].nilaidiskon;
        }
      }
    },
    "model.paym_group": function (newVal) {
      this.model.wo_status = newVal == "WO" ? 1 : 0;
    },
    // "model.ismemo": function (newVal) {
    //   this.model.wo_status = newVal == "BERTAHAP" ? 1 : 0;
    // },
    caraBayar: function (jenis) {
      if (jenis === "Tunai") {
        this.bankOnly = "0";
      } else {
        this.bankOnly = "1";
      }
      // if (this.model.isbank!=this.bankOnly) {
      //     this.model.kodebank='';
      //     this.model.namabank='';
      // }
      if (!this.bankOnly) {
        this.model.kodebank = "";
        this.model.namabank = "";
      }
    },
    bankkas: function (kode) {
      if (this.uanguser.trim() == this.model.matauang.trim()) {
        this.model.kurstrx = 1;
      }
    },
    nilaisettl_desc: function (kode) {
      let pot = this.potongans.find((r) => r.value === kode);
      if (pot) {
        this.arpaymdtObj.Potongan = pot.text;
      }
    },
    "model.tglpaym": function (newVal) {
      if(!this.$route.params.arpaymKey){
        this.model.tgl_terima=moment(newVal).format("YYYY-MM-DD");
      }
    }
  },
  created: async function () {
    this.model.matauang = this.uanguser;
    if (this.$route.params.arpaymKey) {
      toastr.info("Loading Payment Detail, please wait");
      try {
        const [a, d, e, data] = await Promise.all([
          arpayment.currency(),
          await arpayment.potongan(),
          crud.list({
            tablename: "vwcollector",
            page: 1,
            limit: 1000,
            sortBy: "collector_name",
            sortDesc: false,
          }),
          arpayment.arpaymdetail(this.$route.params),
        ]);
        this.currency = a;
        // this.arGroups = c;
        this.potongans = d;
        this.collectors = e.reduce((newArr, item) => {
          newArr.push({ value: item.collector_id, text: item.collector_name });
          return newArr;
        }, []);
        const row = data[0];
        this.saveEnabled = row.statusar === 0;
        row.tglpaym = row.tglpaym
          ? moment(row.tglpaym).format("YYYY-MM-DD")
          : "";
        row.tgl_giro = row.tgl_giro
          ? moment(row.tgl_giro).format("YYYY-MM-DD")
          : "";
        row.tgl_terima = row.tgl_terima
          ? moment(row.tgl_terima).format("YYYY-MM-DD")
          : "";

        for (var key in row) {
          this.model[key] = row[key];
        }
        this.model.pinjamaninfo=`${row.no_agreement}`
        const arpaymdtItm = data[1];
        // this.arpaymdt.items = data[1];
        arpaymdtItm.map(function (item, idx) {
          arpaymdtItm[idx].tgl_jttempo = item.tgl_jttempo
            ? moment(item.tgl_jttempo).format("YYYY-MM-DD")
            : "";
        });
        this.arpaymdt.items = arpaymdtItm;
        this.arpaymdt.total = this.arpaymdt.items.length;
        this.arpaymdt.limit = 10;
        this.calcTotalDtlPaym();
        // this.updateDimHdr = !this.updateDimHdr;
        toastr.clear;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      const collectors = await crud.list({
        tablename: "vwcollector",
        page: 1,
        limit: 0,
        total: 0,
        sortBy: null,
        sortDesc: false,
      });

      this.collectors = collectors.reduce(function (arr = [], item) {
        arr.push({
          value: item.collector_id,
          text: item.collector_name,
        });
        return arr;
      }, []);
      this.collectors.unshift({
        value: "",
        text: "-- Pilih salah satu --",
        disabled: true,
      });
      // this.model.tglpaym = this.model.tglpaym
      //   ? moment(this.model.tglpaym).format("YYYY-MM-DD")
      //   : "";

      this.model.tglpaym = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
      this.model.tgl_terima = moment(this.$store.state.timeServer[this.user.compcode]).format('YYYY-MM-DD');
    }
  },
  methods: {
    showLkuCashflow(callerObj) {
      this.lkuCashflowShow = true;
      this.lkuCashflowCaller = callerObj;
    },
    onSelectLkuPinjaman(_selected){
      this.model.pinjamaninfo =`${_selected.no_agreement}` ;
      this.model.no_kontrak = _selected.no_kontrak;
      this.model.pinjamankey= _selected.pinjamankey;
      this.model.pelunasankey = _selected.pelunasankey;
      this.model.custcode = _selected.CustCode;
      this.model.CustName = _selected.CustName;
      this.model.customer_id = _selected.nasabahkey;
      this.model.collector_id = _selected.collector_id;
      this.model.custinfo =
        _selected.CustCode.trim() + " | " + _selected.CustName.trim();
      this.model.days_over_due = _selected.days_over_due;
      this.model.latecharge_outstand = _selected.latecharge_outstand;
      this.model.principal_outstand = _selected.principal_outstand;
      this.model.interest_outstand = _selected.interest_outstand;
      this.model.principal_outstand_undue = _selected.principal_outstand_undue;
      this.model.interest_outstand_undue = _selected.interest_outstand_undue;
      this.model.next_installment_no = _selected.next_installment_no;
      this.model.next_installment_due_no = _selected.next_installment_due_no;
      this.model.next_installment_date= _selected.next_installment_date ? moment(_selected.next_installment_date).format('DD-MM-YYYY') : _selected.next_installment_date;
      this.model.next_installment_due_date= _selected.next_installment_due_date ? moment(_selected.next_installment_due_date).format('DD-MM-YYYY') : _selected.next_installment_due_date;
      this.model.pbb_os= _selected.pbb_os;
      this.model.uraian = _selected.CustName;
      this.model.compcode = _selected.compcode;
      this.model.model_pinjaman = _selected.model_pinjaman;
      
      this.lkuPinjamanShow = false;
      if(_selected.wo_status == 1){
        this.model.paym_group = "WO";
      }
      if(_selected.pelunasan_bertahap == 1){
        this.model.pelunasan_bertahap = _selected.pelunasan_bertahap;
      }

      if(_selected.pelunasan == 1){
        this.model.pelunasan = _selected.pelunasan;
      }

      this.model.uraian = `Payment Receive${this.model.paym_group=='WO'?' After WO':''} - ${_selected.no_agreement_no_point} - ${_selected.CustName}`;
      

      this.getMemo();
      this.getPelepasanJaminan();
      this.getSP();
    },
    async getMemo(){
      try {
        this.isLoading=true;
        let obj ={
          pinjamankey : this.model.pinjamankey
        };
        const list = await pelunasan.list(obj);
        this.tblDataMemo.items=list;
        this.tblDataMemo.total = list.length;    
        this.isLoading=false; 
        //return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async getPelepasanJaminan(){
      try {
        this.isLoading=true;
        let obj ={
          pinjamankey : this.model.pinjamankey
        };
        const list = await releasedoc.list(obj);
        this.tblDataPelepasanJmn.items=list;
        this.tblDataPelepasanJmn.total = list.length;    
        this.isLoading=false; 
        //return list;
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async getSP(){
      try {
        this.isLoading=true;
        const list = await suratperingatan.getSP(this.model.pinjamankey);
        this.tblDataSP.items=list;
        this.tblDataSP.total = list.length;    
        this.isLoading=false; 
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    onSelectLkuCashflow(_selected) {
      this.arpaymdtObj.cashflow =
        _selected.kodecash.trim() + " | " + _selected.namacash.trim();
      this.arpaymdtObj.kodecash = _selected.kodecash;
      this.arpaymdtObj.namacash = _selected.namacash;
      this.lkuCashflowShow = false;
    },
    save: async function (postToAccounting=0) {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      const opened = this.arpaymdt.items.find((r) => r._showDetails == true);
      if (opened && opened.pinjamankey) {
        toastr.warn("Line/Detail Form Un Saved");
        this.saveEnabled = true;
        return;
      }
      let settl_amt = 0;
      let newArpaymdts = this.arpaymdt.items.reduce((newArr, item) => {
        if ((item.pinjamankey || "") != "") {
          // item.kurspost = this.model.kurstrx;
          settl_amt += item.nilaibank + item.nilaidiskon;
          newArr.push(item);
        }
        return newArr;
      }, []);
      this.model.settl_amt = settl_amt;

      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else if (this.totalDtlPaym > parseFloat(this.model.totalbyr)) {
        toastr.error(
          "[Total Settle. pembayaran] not Balance with [Total Detail Payment]",
          "ERROR MESSAGE"
        );

      } else if (this.totalDtlBank > parseFloat(this.model.totalbank)) {
        toastr.error(
          "[Jumlah Penerimaan Kas/Bank] not Balance with [Total Detail Bank]",
          "ERROR MESSAGE"
        );
      } else if (this.totalDtlDiskon > parseFloat(this.model.totaldiskon)) {
        toastr.error(
          "[Jumlah Potongan/Diskon] not Balance with [Total Detail Diskon]",
          "ERROR MESSAGE"
        );
      } else {
        if (parseFloat(this.model.totalbyr) > this.totalDtlPaym) {
          toastr.warn(
            "[Total Payment Header] is greter than [Total Payment Detail]"
          );
          return;
        }
        this.model.postToAccounting = postToAccounting;
        let res_ = await this.$bvModal.msgBoxConfirm(`Are you sure to Save Data ${postToAccounting==1?'to Accounting ':''}?`, {
          title: 'Please Confirm',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'YES',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        });

        if(res_==true){
          try {
              this.isLoading=true;
              this.model.paymno = this.model.paymno || "";
              this.model.statusar = this.model.statusar || 0;
              this.model.statustre = this.model.statustre || 0;
              this.model.totalbyr = this.model.totalbyr || 0;
              this.model.totalbank = this.model.totalbank || 0;
              this.model.totaldiskon = this.model.totaldiskon || 0;
              this.model.bcharge = this.model.bcharge || 0;
              
              const row = {};
              for (var key in this.model) {
                row[key] = this.model[key];
              }
              row.tglpaym = moment(row.tglpaym).format("YYYY-MM-DD");
              row.tgl_giro = row.tgl_giro
                ? moment(row.tgl_giro).format("YYYY-MM-DD")
                : undefined;
              row.tgl_terima = row.tgl_terima
                ? moment(row.tgl_terima).format("YYYY-MM-DD")
                : moment(row.tglpaym).format("YYYY-MM-DD");
              row.settl_amt = this.model.settl_amt;
              
              row.arpaymdt = newArpaymdts;
              const result = await arpayment.insert2trx(row);
              if(postToAccounting==0){
                arpayment.postingtrx(result).then(res=>{console.log('sukses posting')});
              }
              toastr.success(
                `Payment No : ${result.paymno} ,Complete successfully`,
                "Save & Posting Receipt"
              );
              this.isLoading=false;
              if (this.inputBerlanjut == 0) {
                const arpaylist={};
                const filter = this.$store.state.filter;
                arpaylist.tgl1=  moment(row.tglpaym).format("YYYY-MM-DD");
                arpaylist.tgl2=  moment(row.tglpaym).format("YYYY-MM-DD");
                filter.arpaylist=arpaylist;
                this.$store.commit("filter", filter);
                this.close();
              } else {
                this.saveEnabled = true;
                const jenis = this.model.jenis;
                for (var key in this.model) {
                  this.model[key] = "";
                }
                this.model.jenis = jenis;
                this.model.matauang = this.$store.state.user.matauang;
                this.model.kurstrx = 1;
                this.model.settl_amt = 0;
                this.model.tglpaym = moment().format("YYYY-MM-DD");
                this.totalDtlPaym = 0;
                for (var key in this.arpaymdtObj) {
                  this.arpaymdtObj[key] = "";
                }
                this.arpaymdt.items = [];
                this.arpaymdt.total = 0;
                this.calcTotalDtlPaym();
                this.$v.model.$reset();
              }
            } catch (error) {
              this.isLoading=false;
              console.log("error : ", error);
              if (error.sql) {
                toastr.error(error.sql, "ERROR MESSAGE", 10000);
              } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
              } else if (error.message) {
                toastr.error(error.message, "ERROR MESSAGE", 10000);
              } else {
                toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
              }
              this.saveEnabled = true;
            }

        }else{
          this.saveEnabled =true;
        }
      }
    },
    closeArPayment: function () {
      const opened = this.arpaymdt.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addPaymLoan: function () {
      this.lkuPinjamanoutstandShow = true;
      this.addPrincipInterest = true;
    },
    addArpaymdt: function () {
      let goAhead = true;
      if (this.model.totalbyr) {
        if (this.model.totalbyr - this.totalDtlPaym < 0) {
          goAhead = false;
        }
      }

      if (goAhead == true) {
        this.closeArPayment();
        const obj = { _showDetails: true };
        this.arpaymdt.selected = obj;
        for (var key in this.arpaymdtObj) {
          this.arpaymdtObj[key] = "";
        }
        this.arpaymdtObj.kurssettle = 1;
        this.tabIndex = 0;
        this.arpaymdt.items.push(obj);
        this.arpaymdt.total = this.arpaymdt.items.length;
        setTimeout(() => {
          this.arpaymdt.page = Math.ceil(
            (this.arpaymdt.total + 1) / this.arpaymdt.limit
          );
        }, 100);
      } else {
        toastr.error("UnSettled Amount can not be less then zero");
      }
    },
    editArpaymdt: function (obj, callback) {
      this.closeArPayment();
      this.arpaymdt.selected = obj;
      for (var key in this.arpaymdtObj) {
        this.arpaymdtObj[key] = "";
      }
      for (var key in obj) {
        this.arpaymdtObj[key] = obj[key];
      }
      setTimeout(() => {
        this.tabIndex = this.adaNilaiBank ? 0 : 1;   
        this.arpaymdtObj.nilaisettl = obj.nilaisettl;
        this.arpaymdtObj.nilaibank = obj.nilaibank;
      }, 200);
      callback();
    },
    delArpaymdt: function (index) {
      if (index > -1) {
        this.arpaymdt.items.splice(index, 1);
        const posisi = (this.arpaymdt.page - 1) * this.arpaymdt.limit;
        this.arpaymdt.items.splice(posisi + index, 1);
      }
      const selectedPinjamanOS = [];
      this.arpaymdt.items.map((x) => {
        if (!selectedPinjamanOS.includes(x.angsurankey)) {
          selectedPinjamanOS.push(x.angsurankey);
        }
      });
      this.selectedPinjamanOS = selectedPinjamanOS;
      this.arpaymdt.total = this.arpaymdt.items.length;
      this.calcTotalDtlPaym();
    },
    updateNilaibank: function () {
      if (this.model.matauang == this.arpaymdtObj.matauang) {
        this.arpaymdtObj.nilaibank =
          this.arpaymdtObj.nilaisettl - (this.arpaymdtObj.nilaidiskon || 0);
      }
    },
    saveArpaymdt: function (callback) {
      this.arpaymdtObj.nilaisettl = this.arpaymdtObj.nilaisettl || 0;
      this.arpaymdtObj.nilaidiskon = this.arpaymdtObj.nilaidiskon || 0;
      switch (this.arpaymdtObj.nilaisettl_desc) {
        case "BUNGA":
          this.arpaymdtObj.nilaisettl_pokok = 0;
          this.arpaymdtObj.nilaisettl_bunga = this.arpaymdtObj.nilaisettl;
          this.arpaymdtObj.nilaisettl_denda = 0;
          break;

        case "DENDA":
          this.arpaymdtObj.nilaisettl_pokok = 0;
          this.arpaymdtObj.nilaisettl_bunga = 0;
          this.arpaymdtObj.nilaisettl_denda = this.arpaymdtObj.nilaisettl;
          break;

        default:
          this.arpaymdtObj.nilaisettl_pokok = this.arpaymdtObj.nilaisettl;
          this.arpaymdtObj.nilaisettl_bunga = 0;
          this.arpaymdtObj.nilaisettl_denda = 0;
          break;
      }

      if (this.invalidArpaymdt) {
        console.log("validation : ", this.$v.arpaymdtObj);
        console.log("model obj : ", this.arpaymdtObj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        console.log('this.arpaymdtObj',this.arpaymdtObj);
        let totInvSttl = this.arpaymdt.items.reduce((tot, item) => {
          if (item.pinjamankey == this.arpaymdtObj.pinjamankey) {
            tot + (item.nilaisettl || 0);
          }
          return tot;
        }, this.arpaymdtObj.nilaisettl);

        if(this.arpaymdtObj.nilaisettl_desc=="POKOK"){
          if((this.arpaymdtObj.nilaibank+(this.arpaymdtObj.nilaidiskon || 0))<this.arpaymdtObj.outstand_pokok){
            toastr.warn("Nilai settlement tidak sesuai dengan Settle dg Kas/Bank.", "ERROR MESSAGE",{timeOut: 5000});
            return ;
          }
        }
        if(this.arpaymdtObj.nilaisettl_desc=="BUNGA"){
          if((this.arpaymdtObj.nilaibank+(this.arpaymdtObj.nilaidiskon || 0))<this.arpaymdtObj.outstand_bunga){
            toastr.warn("Nilai settlement tidak sesuai dengan Settle dg Kas/Bank.", "ERROR MESSAGE",{timeOut: 5000});
            return ;
          }
        }
        if (this.arpaymdt.selected.pinjamankey == this.arpaymdtObj.pinjamankey)
          totInvSttl = totInvSttl - (this.arpaymdt.selected.nilaisettl || 0);

        if (totInvSttl - this.arpaymdtObj.outstand_total > 0.01) {
          toastr.error(
            "Settled Amount exceeds Outstanding Amount",
            "ERROR MESSAGE"
          );
        } else {
          this.arpaymdtObj.selisihkurs =
            this.arpaymdtObj.nilaibank +
            this.arpaymdtObj.nilaidiskon -
            this.arpaymdtObj.nilaisettl * this.arpaymdtObj.kurssettle;
          for (var key in this.arpaymdtObj) {
            this.arpaymdt.selected[key] = this.arpaymdtObj[key];
          }
          this.calcTotalDtlPaym();
          this.arpaymdt.selected._showDetails = false;
          if (callback) callback();
          if (this.inputLineBerlanjut == 1) {
            this.addArpaymdt();
            this.$v.arpaymdtObj.$reset();
          }
        }
      }
    },
    confirmPelunasanBertahap(confirm) {
      if(confirm=='No'){
        this.lkuPinjamanoutstandShow = false;
        this.confirmPelunasanBthpShow = false;
      }
      if(confirm=='Yes'){
        this.handleselectPinjamanoutstand(this.selectedOSPinjaman)
      }
    },
    onSelectLkuPinjamanoutstand(invLookup) {
      console.log('invLookup',invLookup);
      if(invLookup.selected.pelunasan_bertahap==1){
        this.selectedOSPinjaman = invLookup;
        this.confirmPelunasanBthpShow = true;
      }else{
        this.handleselectPinjamanoutstand(invLookup) 
      }
    },
    handleselectPinjamanoutstand(invLookup) {
          this.selectedPinjamanOS.push(invLookup.selected.angsurankey);
          this.model.pinjamankey = invLookup.selected.pinjamankey;
          if (this.addPrincipInterest) {
            // const items = ["pokok", "bunga", "denda"];
            const items = ["pokok", "bunga"];
            for (const idx in items) {
              const nilaiByr =
                invLookup.selected[`${"outstand_" + items[idx]}`];
              if ((nilaiByr || 0) == 0) {
                continue;
              }
              if (idx == "pokok" || idx == "bunga") {
                this.minpay += nilaiByr;
              }
              let obj = {};
              for (var key in invLookup.selected) {
                obj[key] = invLookup.selected[key];
              }

              obj.pinjamankey = invLookup.selected.pinjamankey;
              obj.angsurankey = invLookup.selected.angsurankey || "";
              obj.tgl_jttempo = invLookup.selected.tgl_jttempo
                ? moment(invLookup.selected.tgl_jttempo).format("YYYY-MM-DD")
                : "";

              if (obj.matauang.trim() == this.model.matauang.trim()) {
                obj.nilaibank = obj.nilaisettl;
                obj.kurssettle = 1;
                obj.selisihkurs = 0;
              }

              obj.nilaidiskon = 0;
              obj.nilaisettl_desc = items[idx].toUpperCase();
              obj[`nilaisettl_${items[idx]}`]=invLookup.selected[`${"outstand_" + items[idx]}`];
              obj.nilaisettl =
                invLookup.selected[`${"outstand_" + items[idx]}`];
              obj.nilaibank = obj.nilaisettl - (obj.nilaidiskon || 0);
              this.arpaymdt.items.push(obj);
              this.calcTotalDtlPaym();
            }
          } else {
            for (var key in invLookup.selected) {
              this.arpaymdtObj[key] = invLookup.selected[key];
            }
            this.arpaymdtObj.pinjamankey = invLookup.selected.pinjamankey;
            this.arpaymdtObj.angsurankey = invLookup.selected.angsurankey || "";
            this.arpaymdtObj.tgl_jttempo = invLookup.selected.tgl_jttempo
              ? moment(invLookup.selected.tgl_jttempo).format("YYYY-MM-DD")
              : "";

            if (
              this.arpaymdtObj.matauang.trim() == this.model.matauang.trim()
            ) {
              this.arpaymdtObj.nilaibank = this.arpaymdtObj.nilaisettl;
              this.arpaymdtObj.kurssettle = 1;
              this.arpaymdtObj.selisihkurs = 0;
            }
          }

          this.lkuPinjamanoutstandShow = false;
          this.lkuPinjamanoutstandData = invLookup;
    },
    onSelectLkuBankaccount(_selected) {
      this.model.kodebank = _selected.kode;
      this.model.matauang = _selected.matauang;
      this.model.namabank = _selected.namabank;
      this.model.nomorrek = _selected.nomorrek;
      this.model.isbank = _selected.isbank;
      this.lkuBankaccountShow = false;
    },
    onSelectLkuCustomer: async function (_selected) {
      this.model.custinfo =
        _selected.CustCode.trim() + " | " + _selected.CustName.trim();
      this.model.custcode = _selected.CustCode;
      this.model.CustName = _selected.CustName;
      this.model.customer_id = _selected.nasabahkey;
      this.model.collector_id = _selected.collector_id;
      this.lkuCustomerShow = false;
    },

    // updateDimDtl2Hdr: function (dimDtl) {
    //     var dimHdr = this.model;
    //     this.dimension.forEach((dim) => {
    //         if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
    //             dimHdr[dim.value] = dimDtl[dim.value];
    //             dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
    //             dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimHdr = !this.updateDimHdr;
    // },
    // updateDimHdr2Dtl: function (dimDtl) {
    //     var dimHdr = this.model;
    //     dimDtl = dimDtl || this.othPayment.obj;
    //     this.dimension.forEach((dim) => {
    //         if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
    //             dimDtl[dim.value] = dimHdr[dim.value];
    //             dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
    //             dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
    //         }
    //     });
    //     this.updateDimDtl = !this.updateDimDtl;
    // },
    calcTotalDtlPaym: function () {
      let totalDtlPaym = this.model.bcharge || 0;
      let totalDtlBank = this.model.bcharge || 0;
      let totalDtlDiskon = 0;
      totalDtlPaym = totalDtlPaym || 0;
      this.arpaymdt.items.forEach(function (trx) {
        if (trx.pinjamankey) {
          totalDtlPaym =
            totalDtlPaym +
            parseFloat(trx.nilaibank) +
            parseFloat(trx.nilaidiskon);
          totalDtlDiskon = totalDtlDiskon + parseFloat(trx.nilaidiskon);
          // totalDtlBank = totalDtlBank + parseFloat(trx.nilaibank);
        }
      });
      this.totalDtlPaym = totalDtlPaym;
      this.model.totalbyr = totalDtlPaym;
      this.totalDtlBank = totalDtlBank;
      // this.model.totalbank = totalDtlBank;
      this.totalDtlDiskon = totalDtlDiskon;
      this.model.totaldiskon = totalDtlDiskon;
    },
    // close(){
    //   if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name!=='receivable.arpaymfrm'))  {
    //     router.push({name:'receivable.arpaymlist'});
    //   } else {
    //     router.push({name:'receivable.home'});
    //   }
    // }
    close() {
      router.push({ name: "loan.paymlist" });
    },
    viewaggrementcard(){
      const url = router.resolve({name:'loan.agreementcardparams',params:{pinjamankey:this.model.pinjamankey}}).route.path;
      return `#`+url;
    },
  },
};
</script>
